import { Dispatch, SetStateAction, useState } from 'react';

export function useToggle(initialValue = false): [boolean, () => void, Dispatch<SetStateAction<boolean>>] {
  const [value, set] = useState(initialValue);
  const toggle = () => { set(!value); };
  return [value, toggle, set];
}
